import React, { useEffect, useRef, useState } from "react";
import { LuColumns, LuSettings, LuTable2, LuUserPlus } from "react-icons/lu";

export const PROSPECTS_CSS = `
.pz-root { --pz-bg: #f4fafc; --pz-top: #ffffff; --pz-col: #edf6f9; --pz-card: #ffffff; --pz-line: #e6edf0; --pz-line2: #f1f6f8; --pz-ink: #2D2D2D; --pz-ink2: #555555; --pz-ink3: #8B8B8B; --pz-accent: #0a7ba5; --pz-green: #00a37a; --pz-dash: #cfd6d2; --pz-dash2: #c2ccc8; --pz-hover: #ffffffaa; --pz-count: #ffffff;
  display: flex; overflow: hidden; background: var(--pz-bg); font-family: "Avenir LT Std", "Avenir", "Avenir Next", system-ui, sans-serif; }
#body-dark.dark .pz-root { --pz-bg: #0c1317; --pz-top: #111b21; --pz-col: #111b21; --pz-card: #202c33; --pz-line: #2a3942; --pz-line2: #202c33; --pz-ink: #e9edef; --pz-ink2: #aebac1; --pz-ink3: #9fb4b9; --pz-accent: #5DCCED; --pz-dash: #4e606b; --pz-dash2: #4e606b; --pz-hover: #202c33; --pz-count: #202c33; }
.pz-main { display: flex; flex-direction: column; min-width: 0; height: 100%; }
.pz-top { display: flex; align-items: center; gap: 16px; padding: 14px 22px; background: var(--pz-top); border-bottom: 1px solid var(--pz-line); flex-shrink: 0; flex-wrap: wrap; }
.pz-title-wrap { display: flex; flex-direction: column; gap: 2px; flex-shrink: 0; }
.pz-root .pz-title { margin: 0; font-family: inherit; font-size: 26px; font-weight: 600; letter-spacing: 0; line-height: 1.15; color: var(--pz-ink); }
.pz-pipeline { display: inline-flex; align-items: center; gap: 5px; font-size: 12.5px; color: var(--pz-ink3); white-space: nowrap; }
.pz-pipeline strong { color: var(--pz-ink2); font-weight: 600; }
.pz-views { display: flex; gap: 3px; padding: 3px; border-radius: 11px; background: var(--pz-line2); flex-shrink: 0; }
.pz-view { display: inline-flex; align-items: center; gap: 6px; padding: 7px 13px; border: none; border-radius: 9px; background: none; color: var(--pz-ink3); font-family: inherit; font-size: 13.5px; font-weight: 600; cursor: pointer; transition: 0.15s; }
.pz-view:hover { color: var(--pz-ink); }
.pz-view.on { background: var(--pz-top); color: var(--pz-accent); }
.pz-actions { display: flex; align-items: center; gap: 8px; margin-left: auto; }
.pz-gear { position: relative; }
.rail-gear { width: 42px; height: 42px; flex-shrink: 0; display: grid; place-items: center; border: 1px solid var(--pz-line); border-radius: 11px; background: var(--pz-top); color: var(--pz-ink3); cursor: pointer; transition: 0.15s; }
.rail-gear:hover, .rail-gear.on { border-color: #cfdde3; color: var(--pz-ink); }
.pz-gear .su-pop { top: 48px; right: 0; width: 240px; }
.pz-body { position: relative; flex: 1; min-height: 0; }
.kboard { display: flex; align-items: flex-start; gap: 14px; height: 100%; padding: 18px 22px; overflow-x: auto; overflow-y: hidden; }
.kcol { flex: 0 0 296px; max-width: 296px; max-height: 100%; display: flex; }
.kcol-in { display: flex; flex-direction: column; width: 100%; max-height: 100%; border-radius: 16px; background: var(--pz-col); transition: background 0.15s, box-shadow 0.15s; }
.kcol-in.over { background: color-mix(in srgb, var(--pz-accent) 12%, var(--pz-col)); box-shadow: inset 0 0 0 2px color-mix(in srgb, var(--pz-accent) 45%, var(--pz-col)); }
.kcol-head { display: flex; align-items: center; gap: 9px; padding: 13px 12px 10px; cursor: grab; }
.kcol-head:active { cursor: grabbing; }
.kcol-grip { display: grid; place-items: center; margin: 0 -3px 0 -2px; color: #c3c3c3; opacity: 0; transition: 0.12s; flex-shrink: 0; }
.kcol-in:hover .kcol-grip { opacity: 1; }
.kcol-bar { width: 4px; height: 18px; border-radius: 3px; flex-shrink: 0; }
.kcol-name { flex: 1; min-width: 0; font-size: 14.5px; font-weight: 600; letter-spacing: -0.01em; color: var(--pz-ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: text; }
.kcol-count { min-width: 24px; height: 22px; padding: 0 8px; display: grid; place-items: center; border-radius: 11px; background: var(--pz-count); color: var(--pz-ink2); font-size: 12.5px; font-weight: 600; }
.kc-menu { position: relative; }
.kc-menu .su-pop { top: 32px; right: 0; width: 230px; }
.kc-ib { width: 28px; height: 28px; display: grid; place-items: center; border: none; border-radius: 8px; background: none; color: var(--pz-ink3); cursor: pointer; transition: 0.12s; }
.kc-ib:hover, .kc-ib.on { background: var(--pz-hover); color: var(--pz-ink); }
.kcol-body { flex: 1; min-height: 40px; overflow-y: auto; display: flex; flex-direction: column; gap: 9px; padding: 2px 10px 12px; }
.kcol-body > * { flex-shrink: 0; }
.kcol-empty { padding: 18px 10px; border: 1.5px dashed var(--pz-dash); border-radius: 11px; text-align: center; font-size: 12.5px; color: var(--pz-ink3); }
.kcol-add { display: flex; align-items: center; justify-content: center; gap: 7px; padding: 9px; border: none; border-radius: 10px; background: none; color: var(--pz-ink3); font-family: inherit; font-size: 13px; font-weight: 600; cursor: pointer; transition: 0.12s; }
.kcol-add:hover { background: var(--pz-hover); color: var(--pz-accent); }
.kcol-addstage { flex: 0 0 auto; align-self: flex-start; display: inline-flex; align-items: center; gap: 8px; padding: 13px 20px; border: 1.5px dashed var(--pz-dash2); border-radius: 14px; background: color-mix(in srgb, var(--pz-top) 50%, var(--pz-bg)); color: var(--pz-ink2); font-family: inherit; font-size: 13.5px; font-weight: 600; white-space: nowrap; cursor: pointer; transition: 0.15s; }
.kcol-addstage:hover { border-color: var(--pz-accent); color: var(--pz-accent); background: var(--pz-top); }
.kc-form { display: flex; flex-direction: column; gap: 8px; padding: 12px; }
.su-kit .kc-form input { width: 100%; height: 36px; padding: 4px 7px; border: 1px solid var(--pz-accent) !important; border-radius: 7px; outline: none; box-shadow: none !important; background: var(--pz-card) !important; color: var(--pz-ink) !important; font-family: inherit; font-size: 14.5px; font-weight: 600; }
.su-kit .kc-form input::placeholder { color: var(--pz-ink3); font-style: normal; font-weight: 400; }
.kc-form-err { font-size: 12px; color: #d6102f; }
.kc-form-acts { display: flex; justify-content: flex-end; gap: 6px; }
.pc { position: relative; overflow: hidden; padding: 12px 12px 12px 15px; border: 1px solid var(--pz-line); border-radius: 13px; background: var(--pz-card); cursor: pointer; transition: box-shadow 0.15s, border-color 0.15s; }
.pc:hover, .pc.dragging { box-shadow: 0 8px 20px -8px rgba(20, 40, 32, 0.24); }
.pc-spine { position: absolute; left: 0; top: 0; bottom: 0; width: 4px; }
.pc-head { display: flex; align-items: center; gap: 10px; }
.pc-av-wrap { position: relative; flex-shrink: 0; }
.pc-av { width: 40px; height: 40px; display: grid; place-items: center; border-radius: 50%; color: #ffffff; font-size: 13.6px; font-weight: 600; letter-spacing: -0.02em; }
.pc-feel { position: absolute; top: -8px; left: -6px; font-size: 17px; line-height: 1; cursor: help; }
.pc-id { flex: 1; min-width: 0; }
.pc-name { font-size: 14.5px; font-weight: 600; letter-spacing: -0.01em; color: var(--pz-ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.pc-phone { font-size: 12px; color: var(--pz-ink3); }
.pc-tags { display: flex; align-items: center; gap: 5px; margin-top: 10px; flex-wrap: wrap; }
.pc-tag { display: inline-flex; align-items: center; gap: 5px; padding: 1px 7px 1px 6px; border-radius: 999px; font-size: 11px; font-weight: 600; line-height: 1.5; white-space: nowrap; color: color-mix(in srgb, var(--c) 72%, var(--pz-ink)); background: color-mix(in srgb, var(--c) 14%, var(--pz-card)); }
.pc-tag::before { content: ""; width: 6px; height: 6px; border-radius: 2px; background: var(--c); }
.pc-tagmore { font-size: 11px; font-weight: 600; color: var(--pz-ink3); }
.pc-actions { display: flex; align-items: center; gap: 5px; max-height: 0; margin-top: 0; overflow: hidden; opacity: 0; transition: max-height 0.18s ease, opacity 0.15s, margin-top 0.18s; }
.pc:hover .pc-actions, .pc:focus-within .pc-actions { max-height: 48px; margin-top: 11px; opacity: 1; }
@media (hover: none) { .pc-actions { max-height: 48px; margin-top: 11px; opacity: 1; } }
.pc-act { flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 7px 10px; border: 1px solid var(--pz-green); border-radius: 9px; background: var(--pz-green); color: #ffffff; font-family: inherit; font-size: 12.5px; font-weight: 600; cursor: pointer; }
.pc-act:hover { filter: brightness(1.05); }
.su-kit .kcol-name-edit { flex: 1; min-width: 0; height: 28px; padding: 4px 7px; border: 1px solid var(--pz-accent) !important; border-radius: 7px; outline: none; box-shadow: none !important; background: var(--pz-card) !important; color: var(--pz-ink) !important; font-family: inherit; font-size: 14.5px; font-weight: 600; }
.kcol.col-dragging { opacity: 0.45; }
.kcol.pending { opacity: 0.7; }
.kcol.pending .kcol-add { pointer-events: none; }
.kcol-colors { display: flex; flex-wrap: wrap; gap: 6px; padding: 6px 8px; }
.kcol-color { width: 24px; height: 24px; padding: 0; border: 2px solid transparent; border-radius: 7px; cursor: pointer; transition: 0.12s; }
.kcol-color.on { border-color: var(--pz-ink); box-shadow: inset 0 0 0 2px var(--pz-card); }
.su-pop-row:disabled { opacity: 0.4; cursor: default; }
.su-pop-row:disabled:hover { background: none; }
.pz-root ::-webkit-scrollbar { width: 9px; height: 9px; }
.pz-root ::-webkit-scrollbar-track { background: transparent; }
.pz-root ::-webkit-scrollbar-button { display: none; width: 0; height: 0; }
.pz-root ::-webkit-scrollbar-thumb { border: 2px solid transparent; border-radius: 99px; background: #cfdde3; background-clip: content-box; }
.pz-root ::-webkit-scrollbar-thumb:hover { background: #c3c3c3; background-clip: content-box; }
#body-dark.dark .pz-root ::-webkit-scrollbar-thumb { background: #4e606b; background-clip: content-box; }
@supports not selector(::-webkit-scrollbar) { .pz-root, .pz-root * { scrollbar-width: thin; scrollbar-color: #cfdde3 transparent; } }
`;

export const ProspectsHeader = ({ mode, setMode, stagesCount, prospectsCount, onAutomatic }) => {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const onMouseDown = (event) => {
            if (ref.current && !ref.current.contains(event.target)) setOpen(false);
        };
        const onKeyDown = (event) => {
            if (event.key === "Escape") setOpen(false);
        };
        document.addEventListener("mousedown", onMouseDown);
        document.addEventListener("keydown", onKeyDown);
        return () => {
            document.removeEventListener("mousedown", onMouseDown);
            document.removeEventListener("keydown", onKeyDown);
        };
    }, [open]);

    const views = [
        { value: "process", label: "Tablero", icon: LuColumns },
        { value: "table", label: "Tabla", icon: LuTable2 },
    ];

    return (
        <header className="pz-top">
            <div className="pz-title-wrap">
                <h1 className="pz-title">Prospectos</h1>
                <span className="pz-pipeline">
                    <strong>{prospectsCount}</strong> prospecto{prospectsCount === 1 ? "" : "s"} · {stagesCount} etapa{stagesCount === 1 ? "" : "s"}
                </span>
            </div>
            <div className="pz-views" role="tablist" aria-label="Vista">
                {views.map((view) => {
                    const Icon = view.icon;
                    return (
                        <button key={view.value} type="button" role="tab" aria-selected={mode === view.value} className={`pz-view${mode === view.value ? " on" : ""}`} onClick={() => setMode(view.value)}>
                            <Icon className="su-ic" size={16} />
                            {view.label}
                        </button>
                    );
                })}
            </div>
            <div className="pz-actions">
                <div ref={ref} className="pz-gear">
                    <button
                        type="button"
                        className={`rail-gear${open ? " on" : ""}`}
                        aria-label="Configuración"
                        aria-haspopup="menu"
                        aria-expanded={open}
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Configuración"
                        onClick={() => setOpen((value) => !value)}
                    >
                        <LuSettings className="su-ic" size={18} />
                    </button>
                    {open && (
                        <div className="su-pop" role="menu">
                            <button
                                type="button"
                                role="menuitem"
                                className="su-pop-row"
                                onClick={() => {
                                    setOpen(false);
                                    onAutomatic();
                                }}
                            >
                                <LuUserPlus className="su-ic" size={16} />
                                Agregar automáticamente
                            </button>
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
};
